import { IBusinessAttribute } from '@site-mate/sitemate-global-shared';
import { UseFormRegister, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { workspaceService } from '@/services/global-api/workspace.service';

import { createDoNotAcceptWithoutAlphanumericRegex } from '../signup/signup-form-utils';

export interface WorkspaceSetUpProps {
  form: UseFormReturn<WorkspaceSetupFormData>;
  register: UseFormRegister<WorkspaceSetupFormData>;
  onNextStep?: () => void;
}

export const workspaceSetupFormFormSchema = z.object({
  workspaceName: z
    .string()
    .min(1, { message: 'Required' })
    .regex(createDoNotAcceptWithoutAlphanumericRegex(), {
      message: 'Workspace name should have one or more alphanumeric characters.',
    })
    .refine(
      async (workspaceName) => {
        if (!workspaceName) return false;

        return await workspaceService
          .checkForBannedOrReservedWords(workspaceName.toLowerCase())
          .then(() => true)
          .catch(() => false);
      },
      {
        message: 'Workspace names cannot contain inappropriate or reserved terms. Please use a different name.',
      },
    ),
  businessAttributes: z.object({
    vertical: z.custom<IBusinessAttribute>().nullable(),
    role: z.custom<IBusinessAttribute>().nullable(),
    discipline: z.custom<IBusinessAttribute>().nullable(),
  }),
});

export type WorkspaceSetupFormData = z.infer<typeof workspaceSetupFormFormSchema>;
